import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import {
  Angulartics2GoogleAnalytics,
  Angulartics2GoogleGlobalSiteTag,
} from 'angulartics2';
import { WindowRef } from './windowRef';

interface IGa {
  (p1: string, p2?: string, p3?: string): void;
  l?: number;
  q?: any[];
}

declare global {
  interface Window {
    ga: IGa;
    dataLayer: any[];
    gtag(p1: string, p2?: string | Date, p3?: string): void;
  }
}

// lovingly edited from a similar aproach from:
// https://github.com/angulartics/angulartics2/issues/315

/** @dynamic */
@Injectable({
  providedIn: 'root',
})
export class GoogleAnalyticsService {
  constructor(
    public angularticsAnalytics: Angulartics2GoogleAnalytics,
    public angularticsTags: Angulartics2GoogleGlobalSiteTag,
    @Inject(DOCUMENT) private document: Document,
    private winRef: WindowRef,
  ) {}

  loadGoogleAnalytics(analyticsId: string, tagId: string) {
    const window = this.winRef.nativeWindow;

    // Analytics
    // injecting GA main script asynchronously
    const script = this.document.createElement('script');
    script.src = `https://www.google-analytics.com/analytics.js`;
    script.async = true;
    this.document.body.appendChild(script);

    // preparing GA API to be usable even before the async script is loaded
    // see: https://developers.google.com/analytics/devguides/collection/analyticsjs/#alternative_async_tag
    window.ga =
      window.ga ||
      function () {
        (window.ga.q = window.ga.q || []).push(arguments);
      };

    window.ga.l = +new Date();

    window.ga('create', analyticsId, 'auto');

    // Tag Analytics
    // injecting GA main script asynchronously
    const scriptForTag = document.createElement('script');
    scriptForTag.src = `https://www.googletagmanager.com/gtag/js?id=${tagId}`;
    scriptForTag.async = true;
    this.document.body.appendChild(scriptForTag);

    // preparing GA API to be usable even before the async script is loaded
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
    window.gtag('js', new Date());

    // tracking current url at app bootstrap
    window.gtag('config', `${tagId}`);
  }

  startTracking() {
    // activate router navigation tracking
    this.angularticsAnalytics.startTracking();
    this.angularticsTags.startTracking();
  }
}
